<template>
  <div class="m-login">
    <div class="mod-header">
      <h5 class="main-title">赋能企业数字化转型</h5>
      <p class="sub-title">欢迎登录全员营销</p>
    </div>
    <van-form v-if="type === 'password'" @submit="onSubmit" class="m-login-form">
      <van-field
        v-model.trim="account"
        placeholder="请输入账号"
        maxlength="50"
        @blur="handlerBlur"
        @focus="handlerFocus"
      />
      <!-- <van-field
        v-model.trim="userPasswd"
        :type="inputType"
        @input="inputPasswd"
        @focus="handlerFocus"
        @blur="handlerBlur"
        class="user-input-password"
        placeholder="请输入密码"
      >
      </van-field> -->
      <van-field class="img-password-input">
        <div class="mod-input-code-box" slot="input">
          <input class="input-code" @focus="handlerFocus" @blur="handlerBlur"
            placeholder="请输入密码" :type="isPass ? 'password':'text'" v-model.trim="userPasswd" maxlength="50" />
          <i @click="onChangeType" :class="['crm-icon', isPass ? 'icon-yanjing-bi' : 'icon-yanjing']"></i>
        </div>
      </van-field>
      <van-field class="img-code-input">
        <div class="mod-input-code-box" slot="input">
          <input class="input-code" @focus="handlerFocus" @blur="handlerBlur" placeholder="请输入验证码" v-model.trim="code" maxlength="4" />
          <img class="code-img" @click="onfreshCode" :src="imageCodeUrl" />
        </div>
      </van-field>
      <van-button block type="info" :loading="loading"  loading-text="登录中..." :disabled="!account || !userPasswd || !code" native-type="submit" class="m-login-btn">
        登 录
      </van-button>
      <p class="tips-box">
        <span class="tips-text" @click="handleChange('mobile')"><img class="icon-img" src='/imgs/m_phone.png'><label class="icon-text">短信登录</label></span>
        <span class="tips-text">
          <label @click="gotoPassword">忘记密码</label>
          <i class="text-hr"></i>
          <label @click="gotoRegister">注册账号</label>
        </span>
      </p>
    </van-form>
    <van-form v-if="type === 'mobile'" class="m-login-form" @submit="onPhoneSubmit">
      <van-field
        v-model.trim="mobile"
        name="mobile"
        placeholder="请输入注册时的手机号码"
        maxlength="11"
        type="number"
        :error-message="mobileErrMsg"
        @blur="(e) => {
          handlerBlur(e)
          handleCheckMobile(e)
        }"
        @focus="handlerFocus"
      />
      <van-field
        v-model="phoneCode"
        center
        type="number"
        placeholder="请输入短信验证码"
        maxlength="6"
        :error-message="codeErrMsg"
        class="mod-input-mobile-code-box"
        @focus="handlerFocus"
        @blur="(e) => {
          handlerBlur(e)
          handleCheckCode(e)
        }"
        @input="() => { checkForNumber = false }"
      >
        <get-code slot="button" :white-theme="false" @change="onGetCode" />
      </van-field>
      <van-button class="m-login-btn" block type="info" :loading="loading"  loading-text="登录中..." :disabled="!mobile || !phoneCode" native-type="submit">登 录</van-button>
      <p class="tips-box"><span class="tips-text" @click="handleChange('password')"><img class="icon-img" src="/imgs/m_pc.png"><label class="icon-text">账号登录</label></span></p>
    </van-form>
    <p class="mod-footer">Copyright 湖南竞网云数字科技有限公司</p>
  </div>
</template>

<script>
import { analyzeAgent } from '@/pc_login/isMobile.js'
import { Form, Field, Button, Toast, Icon } from 'vant'
import Vue from 'vue'
import 'vant/lib/index.css'
import Api from '../pc_login/api.js'
import getCode from './get-code.vue'
Vue.use(Field)
Vue.use(Form)
Vue.use(Button)
Vue.use(Toast)
Vue.use(Icon)
export default {
  components: {
    getCode
  },
  data () {
    return {
      account: '',
      userPasswd: '',
      code: '',
      guuid: '',
      imageCodeUrl: '',
      loading: false,
      type: 'mobile',
      mobile: '',
      phoneCode: '',
      mobileErrMsg: '',
      codeErrMsg: '',
      checkForNumber: false,
      shouldCheckTotal: false,
      isPass: true
    }
  },
  created () {
    if (!analyzeAgent(navigator.userAgent)) {
      // location.replace(location.origin + location.hash)
      this.$router.push({ path: '/auth', query: this.$route.query })
    }
  },
  mounted () {
    this.shouldCheckTotal = (Number(this.getCookieUtil('_m_mobile_code')) || 0) > 5
    this.onfreshCode()
  },
  methods: {
    onSubmit () {
      this.loading = true
      this.$axios.post('/api/login', { account: this.account, userPasswd: this.userPasswd, loginType: 1, uuid: this.guuid, verifiCode: this.code }).then(res => {
        this.$tools.auth.setToken(res.data.access_token, false)
        let backUrl = this.$route.query.backUrl
        if (backUrl) {
          location.replace(backUrl)
        } else {
          location.replace(location.href)
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
        let errData = err.response.data
        let msg = (errData.errors && errData.errors.map(function (item) {
          return item.message
        }).join(',')) || errData.msg || '系统异常，请稍后再试！'
        Toast(msg)
        this.onfreshCode()
      })
    },
    handlerFocus (el) {
      setTimeout(() => {
        if (el.target.scrollIntoView) {
          el.target.scrollIntoView(false)
        } else {
          document.body.scrollTop = document.body.scrollHeight
        }
      }, 100)
    },
    handlerBlur (el) {
      if (!el.target.scrollIntoView) {
        var ua = navigator.userAgent.toLowerCase()
        if (/iphone|ipad|ipod/.test(ua)) {
          var currentPosition
          var speed = 1
          setTimeout(() => {
            currentPosition = document.documentElement.scrollTop || document.body.scrollTop
            currentPosition -= speed
            window.scrollTo(0, currentPosition)
            currentPosition += speed
            window.scrollTo(0, currentPosition)
          }, 1)
        }
      }
    },
    onfreshCode () {
      Api.getImageCode().then(res => {
        this.imageCodeUrl && (window.URL || window.webkitURL || window.mozURL).revokeObjectURL(this.imageCodeUrl)
        this.guuid = res.headers.uuid
        this.imageCodeUrl = (window.URL || window.webkitURL || window.mozURL).createObjectURL(res.data)
      }).catch(({ response }) => {
        Api.message(Toast, response)
      })
    },
    inputPasswd (e) {
      let reg = /[\s\u2E80-\u2EFF\u2F00-\u2FDF\u3000-\u303F\u31C0-\u31EF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FBF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF]+/g
      this.userPasswd = ''
      this.$nextTick(() => {
        this.userPasswd = e.target.value.replace(reg, '')
      })
    },
    handleChange (type) {
      this.type = type
      this.account = ''
      this.userPasswd = ''
      this.code = ''
      this.mobile = ''
      this.phoneCode = ''
      this.mobileErrMsg = ''
      this.codeErrMsg = ''
    },
    gotoPassword () {
      window.sessionStorage.setItem('backUrl', this.$route.query.backUrl || '')
      this.$router.push({ path: '/m-auth/get-password' })
    },
    gotoRegister () {
      const backUrl = this.$route.query.backUrl
      let partnerId = null
      if (backUrl) {
        let reg = new RegExp('(^|&)partnerId=([^&]*)(&|$)') // 构建一个含有目标参数的正则表达式对象
        if (backUrl.indexOf('?') > -1) {
          let r = backUrl.split('?')[1].match(reg)
          if (r != null) {
            partnerId = unescape(r[2])
          }
        }
      }
      this.$router.push({ path: '/m-auth/register', query: partnerId ? { partnerId } : {} })
    },
    setCookieUtil (name, value, expires) {
      let cookieText = ''
      cookieText += encodeURIComponent(name) + '=' + encodeURIComponent(value)
      if (expires instanceof Date) {
        cookieText += '; expires=' + expires.toGMTString()
      } else {
        cookieText += '; expires=' + new Date(new Date().getTime() + 12 * 60 * 60 * 1000).toGMTString()
      }
      document.cookie = cookieText
    },
    getCookieUtil (name) {
      const cookieName = encodeURIComponent(name) + '='
      const cookieStart = document.cookie.indexOf(cookieName)
      let cookieValue = ''
      if (cookieStart !== -1) {
        let cookieEnd = document.cookie.indexOf(';', cookieStart)
        if (cookieEnd === -1) {
          cookieEnd = document.cookie.length
        }
        cookieValue = decodeURIComponent(document.cookie.substring(cookieStart + cookieName.length, cookieEnd))
      }
      return cookieValue
    },
    handleCheckMobile (e) {
      const callback = typeof e === 'function' ? e : ''
      if (!this.mobile) {
        this.mobileErrMsg = '请输入手机号码'
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(false)
      } else if (!/^1[0-9]{10}$/.test(this.mobile)) {
        this.mobileErrMsg = '请输入正确的手机号码'
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(false)
      } else {
        Api.CheckPhoneValidate(this.mobile).then(({ data }) => {
          if (data.result) {
            this.mobileErrMsg = ''
            // eslint-disable-next-line standard/no-callback-literal
            callback && callback(true)
          } else {
            this.mobileErrMsg = '该手机号未注册'
            // eslint-disable-next-line standard/no-callback-literal
            callback && callback(false)
          }
        }).catch(({ response }) => {
          Api.message(Toast, response)
        })
      }
    },
    handleCheckCode (e) {
      const callback = typeof e === 'function' ? e : ''
      if (!this.phoneCode && !this.checkForNumber) {
        this.codeErrMsg = '请输入验证码'
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(false)
      } else if (!/^\d{6}$/.test(this.phoneCode)) {
        this.codeErrMsg = '请输入6位数验证码'
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(false)
      } else if (this.checkForNumber) {
        this.codeErrMsg = '操作过于频繁，请休息5分钟再试'
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(false)
      } else if (/^1[0-9]{10}$/.test(this.mobile)) {
        // Api.checkPhoneCode({
        //   phone: this.mobile,
        //   type: 2,
        //   code: this.phoneCode
        // }).then(res => {
        //   this.codeErrMsg = ''
        //   // eslint-disable-next-line standard/no-callback-literal
        //   callback && callback(true)
        // }).catch(res => {
        //   const response = res.response
        //   if (response && response.status === 400 && response.data && (response.data.msg === '验证码错误' || response.data.msg === '验证码已失效，请重新获取' || response.data.msg === '验证码已失效,请重新获取')) {
        //     this.codeErrMsg = response.data.msg
        //     // eslint-disable-next-line standard/no-callback-literal
        //     callback && callback(false)
        //   } else {
        //     Api.message(Toast, res.response)
        //     // eslint-disable-next-line standard/no-callback-literal
        //     callback && callback(false)
        //   }
        // })
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(true)
      } else {
        this.mobileErrMsg = '请输入正确的手机号码'
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(false)
      }
    },
    onGetCode (done) {
      this.handleCheckMobile((e) => {
        if (e) {
          const total = Number(this.getCookieUtil('_m_mobile_code')) || 0
          if (total === 5) {
            this.shouldCheckTotal = true
            this.setCookieUtil('_m_mobile_code', 6, new Date(Date.now() + 5 * 60 * 1000))
            setTimeout(() => {
              this.shouldCheckTotal = false
            }, 5 * 60 * 1000)
            this.checkForNumber = true
            this.handleCheckCode()
          }
          if (total > 5) {
            this.checkForNumber = true
            this.handleCheckCode()
          }
          if (total < 5) {
            this.codeErrMsg = ''
            this.setCookieUtil('_m_mobile_code', total + 1, new Date(Date.now() + 2 * 60 * 1000))
            Api.postPhoneCode({
              phone: this.mobile,
              type: 1
            }).catch(({ response }) => {
              Api.message(Toast, response)
            })
            done && done()
          }
        }
      })
    },
    onChangeType () {
      this.isPass = !this.isPass
    },
    onPhoneSubmit () {
      this.handleCheckMobile((e) => {
        if (e) {
          this.handleCheckCode((result) => {
            if (result) {
              this.loading = true
              this.$axios.post('/api/login', { account: this.mobile, loginType: 2, verifiCode: this.phoneCode }).then(res => {
                this.$tools.auth.setToken(res.data.access_token, false)
                let backUrl = this.$route.query.backUrl
                if (backUrl) {
                  location.replace(backUrl)
                } else {
                  location.replace(location.href)
                }
                this.loading = false
              }).catch(res => {
                this.loading = false
                const response = res.response
                if (response && response.status === 400 && response.data && (response.data.msg === '验证码错误' || response.data.msg === '验证码已失效，请重新获取' || response.data.msg === '验证码已失效,请重新获取')) {
                  this.codeErrMsg = response.data.msg
                } else {
                  Api.message(Toast, res.response)
                }
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .m-login {
    background-color: #F6F8FB;
    min-height: 100vh;
    text-align: center;
    .mod-header{
      width: 100%;
      height: 205px;
      margin: 0 auto;
      position: relative;
      background-size: 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url('/imgs/m_header.png');
      background-color: transparent;
      .main-title{
        font-size: 24px;
        color: #FFFFFF;
        height: 33px;
        line-height: 33px;
        margin: 0 auto;
        padding-top: 40px;
        font-weight: 600;
        text-align: center;
        box-sizing: content-box;
      }
      .sub-title{
        font-size: 15px;
        color: #FFFFFF;
        height: 21px;
        line-height: 21px;
        text-align: center;
        padding-top: 8px;
      }
    }
  }
  .m-login-form {
    margin: 0px 30px 0;
  }
</style>
<style lang="less">
  html,body {
    width: 100%;
    min-height: 100vh;
  }
  .m-login {
    .van-field__control {
      color: #333 ;
      background-color: transparent;
      &::placeholder {
        color: #999;
        -webkit-text-fill-color: #999;
      }
      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:-webkit-autofill:active {
        -webkit-transition-delay: 99999s;
        -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
        }
    }
    input::placeholder {
        color: #999;
        -webkit-text-fill-color: #999;
      }
    .van-cell {
      background-color: #F6F8FB;
      border-radius: 4px;
      padding: 0;
      &::after{
        border-bottom:none;
      }
      &+.van-cell {
        margin-top: 20px;
      }
      .van-field__control{
        padding: 10px 16px;
        -webkit-appearance: none;
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        box-sizing: border-box;
        &:focus, &:active{
          outline: none;
          border-color: #409eff;
        }
      }
      &.img-password-input .van-field__control{
        height: 46px;
        padding: 0;
        .mod-input-code-box{
          position: relative;
          width: 100%;
          box-sizing: border-box;
          .input-code{
            padding: 10px 30px 10px 16px;
            -webkit-appearance: none;
            background-color: #fff;
            background-image: none;
            box-sizing: border-box;
            width: 100%;
            border: none;
            outline: none;
            &:focus, &:active{
              outline: none;
              border-color: #409eff;
            }
          }
          .crm-icon{
            position: absolute;
            right: 10px;
            top: 10px;
            font-size: 20px;
          }
        }
      }
      &.img-code-input .van-field__control{
        padding: 0;
        background-color: #F6F8FB;
        background-color: #F6F8FB;
        border: none;
        border-radius: 0;
        height: 46px;
        .mod-input-code-box{
          position: relative;
          width: 100%;
          box-sizing: border-box;
          padding-right: 110px;
          .input-code{
            padding: 10px 16px;
            -webkit-appearance: none;
            background-color: #fff;
            background-image: none;
            border-radius: 4px;
            border: 1px solid #dcdfe6;
            box-sizing: border-box;
            width: 100%;
            &:focus, &:active{
              outline: none;
              border-color: #409eff;
            }
          }
          .code-img{
            position: absolute;
            right: 0;
            top: 0px;
            height: 46px;
            width: 100px;
            border-radius: 4px;
          }
        }
      }
      &.mod-input-mobile-code-box .van-field__button{
        position: absolute;
        top: 4px;
        right: 10px;
        padding: 0;
      }
      &.user-input-password{
        .van-field__control{
          padding-right: 30px;
        }
        .van-field__right-icon{
          position: absolute;
          right: 10px;
          top: 10px;
        }
      }
    }
    .m-login-btn {
      margin: 30px 0px 0;
      border-radius: 6px;
    }
    .tips-box{
      padding-top: 20px;
      text-align: left;
      // padding-left: 16px;
      display: flex;
      justify-content: space-between;
      color: #333;
      &:active{
        color: #000;
      }
      .tips-text{
        font-size: 14px;
        color: #333;
        display: flex;
        align-items: center;
        &:active{
          color: #000;
        }
        .text-hr{
          display:block;
          height: 14px;
          width: 1px;
          background: #999;
          margin: 0 10px;
        }
      }
      .icon-img{
        display: inline-block;
        width: 18px;
        height: 18px;
        vertical-align: top;
      }
      .icon-text{
        display: inline-block;
        font-size: 14px;
        color: #333;
        padding-left: 4px;
      }
    }
    @media screen and (max-height: 600px) {
      .mod-footer{
        height: 40px;
        line-height: 40px;
        color: #999;
        font-size: 12px;
        text-align: center;
        width: 100%;
      }
    }
    @media screen and (min-height: 600px) {
      .mod-footer{
        position: fixed;
        bottom: 20px;
        color: #999;
        font-size: 12px;
        text-align: center;
        width: 100%;
        left: 0;
        right: 0;
      }
    }
  }
</style>
